import {RouteInterfaceType} from "@twigsby/frontend-framework";
import React from "react";
import Overview from "../Pages/Overview";
import MessageCentreRoutes from "./MessageCentreRoutes";
import {PublicRoutes} from "./PublicRoutes";
import {StandaloneSendsAdminUsersRoutes, StandaloneSendsUsersRoutes} from "./StandaloneSendsRoutes";
import {ManageAccountRoutes} from "./ManageAccountRoutes";

export interface SuggestibleRouteInterface extends RouteInterfaceType {
    description?: string;
    skipSuggestion?: boolean;
    children?: any;
}

const TopRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Overview',
        path: '/',
        element: <Overview/>,
    },
    ...StandaloneSendsUsersRoutes,
    ...StandaloneSendsAdminUsersRoutes,
    ...ManageAccountRoutes,
];

export default TopRoutes;
